/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import { useState } from 'react';
import { Page, Table, Toolbar } from 'components';
import { TemplatesHeader as header } from 'containers';
import { MenuItem, Select } from '@mui/material';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { useQuery } from 'react-query';

export default function TemplatesListPage() {
  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);

  const [query, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 15),
    sortBy: withDefault(StringParam, 'createdAt'),
    sortOrder: withDefault(StringParam, 'desc'),
    keyword: withDefault(StringParam, ''),
    status: withDefault(NumberParam, -1),
  });

  const { data, isLoading, error, refetch } = useQuery(
    [query.limit, query.page, query.keyword, query.sortBy, query.sortOrder, query.status],
    () => {
      const url = `/admin/site/search`;
      axios
        .get(url, {
          params: {
            ...query,
            status: query.status === -1 ? undefined : query.status,
            sortOrder: query.sortOrder === 'desc' ? -1 : 1,
          },
        })
        .then(({ data }) => {
          setList(data.data);
          setCount(data.count);
        });
    }
  );

  const onPageChange = (_, newValue) => {
    setQuery({ ...query, page: newValue });
  };
  const onRowsPerPageChange = (event) => {
    setQuery({ ...query, limit: event.target.value });
  };
  const handleRequestSort = (event, property) => {
    const isAsc = query.sortBy === property && query.sortOrder === 'asc';
    setQuery({ ...query, sortOrder: isAsc ? 'desc' : 'asc', sortBy: property });
  };
  const handleChange = (value) => {
    setQuery({ ...query, keyword: value, page: 1 });
  };
  const handleChangeFilter = (event) => {
    setQuery({ ...query, status: event.target.value, page: 1 });
  };

  const paginate = {
    page: query.page,
    rowsPerPage: query.limit,
    count,
    order: query.sortOrder,
    orderBy: query.sortBy,
    onPageChange,
    onRowsPerPageChange,
  };
  const actions = {
    handleRequestSort,
    cb: refetch,
  };
  const TOOLBAR_ACTION = {
    name: 'templates',
    handleChange,
    query,
    setQuery,
    filters: (
      <Select label="وضعیت" value={query.status} onChange={handleChangeFilter}>
        {TEMPLATE_STATUS.map((status, index) => (
          <MenuItem value={status.value} key={index}>
            {status.label}
          </MenuItem>
        ))}
      </Select>
    ),
  };

  return (
    <Page title="لیست درخواست ها">
      <Toolbar name="templates" action={TOOLBAR_ACTION} />

      <Table name="templates" header={header} rows={list} actions={actions} paginate={paginate} isLoading={isLoading} />
    </Page>
  );
}

export const TEMPLATE_STATUS = [
  { value: -1, label: 'همه' },
  { value: 1, label: 'پیش نویس' },
  { value: 2, label: 'منتظر بررسی' },
  { value: 3, label: 'فعال' },
  { value: 4, label: 'رد شده' },
  { value: 5, label: 'غیر فعال (جایگاه غیر فعال)' },
];
